var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pix-frame",attrs:{"height":_vm.height,"id":"payment-info"},domProps:{"innerHTML":_vm._s(_vm.response)}})}
var staticRenderFns = []

export { render, staticRenderFns }